<template>
  <apexchart
    :width="isMobile ? '100%' : width"
    :height="height"
    type="bar"
    :options="chartOptions"
    :series="chartData"
  >
  </apexchart>
</template>

<script>
import helpers from '../mixins/statsHelperFunc'
import icd10Chapters from '@/content/icd/icd-10-cm-chapters.json'
import apexchart from 'vue-apexcharts'
export default {
  components: {
    apexchart
  },
  props: {
    statsData: { type: Object },
    logs: { type: Array },
    height: { type: String, default: '580' },
    width: { type: String, default: '800' }
  },
  mixins: [helpers],
  data() {
    return {
      allComponents: this.allStatsComponents(this.statsData.logbookType),
      theme: {
        palette: 'palette5',
        monochrome: {
          enabled: false,
          color: '#d9d9d9',
          shadeTo: 'light',
          shadeIntensity: 0.65
        }
      }
    }
  },
  mounted() {
    this.$root.$emit('isTable', false)
    this.$root.$on('selectedStyle', style => {
      this.theme = Object.assign({}, this.theme, style.theme)
    })
  },
  computed: {
    row1Values() {
      const row1 = this.statsData.variables.row1
      const row1Values = this.getColumnOptions(
        row1,
        this.allComponents,
        this.logs
      )
      return row1Values
    },
    column1Values() {
      const column1 = this.statsData.variables.column1
      return this.getColumnOptions(column1, this.allComponents, this.logs)
    },
    labels() {
      if (this.isICD10) {
        return ['Diagnosticos por Capitulo']
      } else {
        return this.column1Values.length
          ? this.column1Values.map(c =>
              c.text.length > 25 ? c.text.substring(0, 15) + '...' : c.text
            )
          : this.row1Values.map(c =>
              c.text.length > 25 ? c.text.substring(0, 15) + '...' : c.text
            )
      }
    },
    chartOptions() {
      let legendPosition = this.isMobile ? 'top' : 'right'
      let options = {
        xaxis: {
          categories: this.labels
        },
        chart: {
          animations: {
            enabled: false,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: false,
              delay: 150
            },
            dynamicAnimation: {
              enabled: false,
              speed: 350
            }
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '100%',
            endingShape: 'rounded'
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        legend: {
          show: true,
          position: legendPosition
        },
        theme: this.theme
      }
      return options
    },
    chartData() {
      const datasets = this.row1Values.map(r => ({
        name: r.text,
        data: this.normalData(r)
      }))
      return this.isICD10 ? this.icd10Data() : datasets
    },
    isICD10() {
      if (
        this.statsData &&
        this.statsData.variables &&
        this.statsData.variables.row1
      ) {
        return (
          this.statsData.variables.row1.type === 'icd10' ||
          this.statsData.variables.row1.type === 'icd10-sec'
        )
      } else {
        return false
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    normalData(r) {
      return (
        this.column1Values.length ? this.column1Values : [{ value: null }]
      ).map(c =>
        this.getCount(
          this.logs,
          {
            row1: this.statsData.variables.row1,
            column1: this.statsData.variables.column1
          },
          {
            column1Value: c.value,
            row1Value: r.value
          }
        )
      )
    },
    icd10Data() {
      let dataArr = []
      if (
        this.statsData &&
        this.statsData.variables &&
        this.statsData.variables.row1
      ) {
        icd10Chapters.map((chapter, index) => {
          chapter.min = chapter['chapter_code'].split('-')[0]
          chapter.max = chapter['chapter_code'].split('-')[1]
          chapter.roman = this.romanize(index + 1)
          let diagnostics = []
          this.ICD10logs(this.statsData.variables.row1.id).map(log => {
            log[this.statsData.variables.row1.id].map(diagnostic => {
              const code = diagnostic.split(':')[0]
              if (code >= chapter.min && code <= chapter.max) {
                const index = diagnostics.findIndex(
                  item => item.section_code === code
                )
                if (index !== -1) {
                  diagnostics[index].count++
                } else {
                  diagnostics.push({
                    section_code: code,
                    count: 1,
                    description: diagnostic.split(':')[1]
                  })
                }
              }
              chapter.diagnostics = diagnostics
            })
          })

          dataArr.push({
            name: `${chapter.roman} ${chapter.chapter_description}`,
            data: [
              chapter.diagnostics.reduce((a, b) => {
                return a + b['count']
              }, 0)
            ]
          })
        })
        dataArr = dataArr.filter(data => data.data[0] !== 0)
      }
      return dataArr
    }
  }
}
</script>
